export default __webpack_public_path__ + "static/media/foodfriends-print.6e934da6.png";